import React, { useState, useEffect, useMemo, useRef } from "react";
import axios from "axios";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import "../../assets/Loan/CollectionReport.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { useNavigate } from "react-router-dom";

const DepositCollectionReport = () => {
    const superAdminId = Number(localStorage.getItem("userId")) || 0;
      

  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);
  const navigate=useNavigate();

  const [records, setRecords] = useState([]);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedLoan, setSelectedLoan] = useState(null);

  const slipRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
      dispatch(fetchUserProfile());
    }, [dispatch]);

  const API_URL = `https://narrowitsolution.in/api/installments/paid?branchId=${superAdminId}`;

  // ---------------- FETCH INSTALLMENTS ----------------
  useEffect(() => {
    const fetchRecords = async () => {
      setLoading(true);
      try {
        const res = await axios.get(API_URL);
        setRecords(res.data?.data || []);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    fetchRecords();
  }, [API_URL]);

  // ---------------- FETCH COMPANY ----------------
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://narrowitsolution.in/api/get-company?superAdminId=${profile?.superAdminId}`
        );
        const data = await res.json();
        if (res.ok && data) {
          if (data.logo)
            data.logoUrl = `https://narrowitsolution.in/${data.logo.replace(/^images\//, "")}`;
          setCompany(data);
        }
      } catch (err) {
        console.error("Failed to fetch company details", err);
      }
    };
    fetchCompany();
  }, [profile?.superAdminId]);

  
  const ViewDepositeCollectionReceipt=(depoCollection)=>{
    navigate(`/Banking/DepositCollectionReceipt/${depoCollection.id}`,{state:{depoCollection}})
  }

  // ---------------- SEARCH FILTER ----------------
  const filteredData = useMemo(() => {
    if (!searchQuery.trim()) return records;

    const query = searchQuery.toLowerCase();

    return records.filter((item) =>
      [
        item.account?.customerName,
        item.account?.accountNo,
        item.installmentNo,
        item.amount,
        item.status,
        item.dueDate,
      ]
        .join(" ")
        .toLowerCase()
        .includes(query)
    );
  }, [records, searchQuery]);

  // ---------------- PAGINATION ----------------
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentData = filteredData.slice(
    startIndex,
    startIndex + rowsPerPage
  );

  const handlePrev = () => currentPage > 1 && setCurrentPage((p) => p - 1);
  const handleNext = () =>
    currentPage < totalPages && setCurrentPage((p) => p + 1);

  // ---------------- TOTAL AMOUNT ----------------
  const totalAmount = currentData.reduce(
    (acc, r) => acc + (r.amount || 0),
    0
  );

  // ---------------- EXPORT TABLE PDF ----------------
  // const downloadPDF = () => {
  //   const doc = new jsPDF("p", "mm", "a4");
  //   const pageWidth = doc.internal.pageSize.width;

  //   doc.setFont("helvetica", "bold");
  //   doc.setFontSize(15);
  //   doc.text("Deposit Collection Report", pageWidth / 2, 14, {
  //     align: "center",
  //   });

  //   autoTable(doc, {
  //     startY: 22,
  //     head: [
  //       [
  //         "Sr",
  //         "Customer",
  //         "Account No",
  //         "Installment",
  //         "Amount",
  //         "Due Date",
  //         "Paid Date",
  //         "Mode",
  //       ],
  //     ],
  //     body: currentData.map((r, i) => [
  //       startIndex + i + 1,
  //       r.account?.customerName,
  //       r.account?.accountNo,
  //       r.installmentNo,
  //       r.amount,
  //       new Date(r.dueDate).toLocaleDateString("en-IN"),
  //       r.collectionDate
  //         ? new Date(r.collectionDate).toLocaleDateString("en-IN")
  //         : "-",
  //       r.collectionType || "-",
  //     ]),
  //     theme: "grid",
  //   });

  //   doc.save("Deposit_Collection_Report.pdf");
  // };

  const downloadPDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
  
    // ================= LOGO =================
  // ================= LOGO WITH BORDER =================
  const logoX = 15;
  const logoY = 12;
  const logoSize = 25;
  const logoPadding = 2;
  
  // Border color & thickness
  doc.setDrawColor(0);
  doc.setLineWidth(0.2);
  
  // Calculate center of logo
  const centerX = logoX + logoSize / 2;
  const centerY = logoY + logoSize / 2;
  
  // Radius = half of logo + padding
  const radius = logoSize / 2 + logoPadding;
  
  // Draw circle
  doc.circle(centerX, centerY, radius);
  
  
  // Logo image
  if (company?.logoUrl) {
    try {
      const logoResp = await fetch(company.logoUrl);
      const logoBlob = await logoResp.blob();
      const reader = new FileReader();
      await new Promise((resolve) => {
        reader.onload = () => {
          doc.addImage(reader.result, "PNG", logoX, logoY, logoSize, logoSize);
          resolve();
        };
        reader.readAsDataURL(logoBlob);
      });
    } catch {
      // silent fail
    }
  }
  
  
    // ================= COMPANY NAME (AUTO WRAP) =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
  
    const nameX = logoX + logoSize + 5;
    const nameY = 18;
    const nameMaxWidth = pageWidth - nameX - 15;
  
    const companyNameText = doc.splitTextToSize(
      (company?.name || "COMPANY NAME").toUpperCase(),
      nameMaxWidth
    );
  
    doc.text(companyNameText, nameX, nameY);
  
    // Calculate Y after company name
    let currentY = nameY + companyNameText.length * 6;
  
    // ================= COMPANY DETAILS =================
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
  
    const detailX = nameX;
    const detailMaxWidth = nameMaxWidth;
  
    // Address
    const addressText = doc.splitTextToSize(
      company?.address || "Company Address",
      detailMaxWidth
    );
    doc.text(addressText, detailX, currentY);
    currentY += addressText.length * 5;
  
    // Email
    const emailText = doc.splitTextToSize(
      `Email: ${company?.email || "-"}`,
      detailMaxWidth
    );
    doc.text(emailText, detailX, currentY);
    currentY += emailText.length * 5;
  
    // Phone
    const phoneText = doc.splitTextToSize(
      `Phone: ${company?.contact || "-"}`,
      detailMaxWidth
    );
    doc.text(phoneText, detailX, currentY);
    currentY += phoneText.length * 5;
  
    // Divider
    doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);
  
    // ================= REPORT TITLE =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.text(
      "Deposit Collection Report",
      pageWidth / 2,
      currentY + 14,
      { align: "center" }
    );
  
    // ================= TABLE =================
    const tableColumn = [
      "Sr",
          "Customer",
          "Account No",
          "Installment",
          "Amount",
          "Due Date",
          "Paid Date",
          "Mode",
    ];
  
    const tableRows = currentData.map((r, index) => [
      startIndex + index + 1,
      r.account?.customerName,
      r.account?.accountNo,
      r.installmentNo,
      r.amount,
      new Date(r.dueDate).toLocaleDateString("en-IN"),
      r.collectionDate
        ? new Date(r.collectionDate).toLocaleDateString("en-IN")
        : "-",
      r.collectionType,
    ]);
  
    const totalRow = [
      { content: "Total", colSpan: 4, styles: { halign: "right", fontStyle: "bold" } },
      { content: totalAmount.toLocaleString("en-IN"), styles: { fontStyle: "bold" } },
      "", "", ""
    ];
  
autoTable(doc, {
  startY: currentY + 20,
  head: [tableColumn],
  body: tableRows,
  foot: [totalRow],

  showFoot: "lastPage", // 🔥 IMPORTANT LINE

  theme: "grid",
  styles: {
    fontSize: 7,
    cellPadding: 3,
    halign: "center",
  },
  headStyles: {
    fontStyle: "bold",
    fontSize: 7,
  },
  footStyles: {
    fillColor: [220, 220, 220],
    textColor: 20,
    fontStyle: "bold",
    fontSize: 8,
  },
  alternateRowStyles: {
    fillColor: [245, 245, 245],
  },

  didDrawPage: function () {
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    doc.setDrawColor(0);
    doc.setLineWidth(0.2);

    // Page border on EVERY page
    doc.rect(8, 8, pageWidth - 16, pageHeight - 16);
  },
});

  
    // ================= FOOTER =================
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(100);
      doc.text(
        `Page ${i} of ${pageCount}`,
        pageWidth - 30,
        pageHeight - 10
      );
      doc.text(
        "Generated by Collection System",
        14,
        pageHeight - 10
      );
    }
  
    doc.save("Deposit_Collection_Report.pdf");
  };

  // ---------------- A5 PDF SLIP ----------------
  const handleDownloadSlip = (data) => {
    const doc = new jsPDF("p", "pt", "a5");
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 20;
    let y = margin;

    try {
      if (company?.logoUrl)
        doc.addImage(company.logoUrl, "PNG", margin, y, 50, 50);
    } catch {}

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text(company?.name || "Company Name", margin + 60, y + 20);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text(`Address: ${company?.address || "-"}`, margin + 60, y + 50);

    y += 95;
    doc.line(margin, y, pageWidth - margin, y);
    y += 10;

    doc.setFont("helvetica", "bold");
    doc.text("Deposit Collection Slip", margin, y);
    y += 8;

    autoTable(doc, {
      startY: y,
      theme: "plain",
      styles: { fontSize: 9, cellPadding: 3 },
      body: [
        [{ content: `Customer Name: ${data?.account?.customerName || "-"}` }],
        [{ content: `Account No: ${data?.account?.accountNo || "-"}` }],
        [{ content: `Installment No: ${data?.installmentNo || "-"}` }],
        [{ content: `Amount: Rs. ${data?.amount || "-"}` }],
        [
          {
            content: `Paid Date: ${
              data.collectionDate
                ? new Date(data.collectionDate).toLocaleDateString("en-IN")
                : "-"
            }`,
          },
        ],
        [{ content: `Mode: ${data?.collectionType || "-"}` }],
      ],
    });

    doc.save(
      `DepositSlip_${data?.account?.customerName || "Customer"}.pdf`
    );
  };

  // ---------------- THERMAL PRINT ----------------
  const handlePrintThermalSlip = async (loan) => {
    if (!slipRef.current) return;

    setSelectedLoan(loan);

    const html2canvas = (await import("html2canvas")).default;

    const canvas = await html2canvas(slipRef.current, {
      scale: 3,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/png");

    try {
      const printWindow = window.open("", "_blank", "width=1000,height=600");

      printWindow.document.write(`
        <html>
          <head>
            <title>Print Slip</title>
            <style>
              @page { size: 58mm auto; margin:0; }
              body { margin:0; padding:0; text-align:center; }
              img { width:58mm; max-width:58mm; }
            </style>
          </head>
          <body>
            <img src="${imgData}" />
          </body>
        </html>
      `);

      printWindow.document.close();

      printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();
        setTimeout(() => printWindow.close(), 500);
      };
    } catch {
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: [58, (canvas.height * 58) / canvas.width],
      });
      pdf.addImage(imgData, "PNG", 0, 0, 58, (canvas.height * 58) / canvas.width);
      pdf.save(
        `DepositSlip_${loan?.account?.customerName || "Customer"}.pdf`
      );
    }
  };

  // ---------------- UI ----------------
  return (
    <div className="CollectionReport-wrapper">
      <h1 className="CollectionReport-title">📋 Deposit Collection Report</h1>

      <div className="CollectionReport-controls">
        <label>
          Show{" "}
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={50000}>All</option>
          </select>{" "}
          entries
        </label>

        <input
          type="search"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />

        <button className="filter-btn" onClick={downloadPDF}>
          📄 Download PDF
        </button>
      </div>

      <div className="CollectionReport-table-container">
        {loading ? (
          <p className="CollectionReport-loading">⏳ Loading...</p>
        ) : (
          <table className="CollectionReport-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Customer</th>
                <th>Account No</th>
                <th>Installment No</th>
                <th>Amount</th>
                <th>Due Date</th>
                <th>Paid Date</th>
                <th>Mode</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {currentData.map((r, idx) => (
                <tr key={r.id}>
                  <td>{startIndex + idx + 1}</td>
                  <td>{r.account?.customerName}</td>
                  <td>{r.account?.accountNo}</td>
                  <td>{r.installmentNo}</td>
                  <td>₹{r.amount}</td>
                  <td>
                    {new Date(r.dueDate).toLocaleDateString("en-IN")}
                  </td>
                  <td>
                    {r.collectionDate
                      ? new Date(r.collectionDate).toLocaleDateString(
                          "en-IN"
                        )
                      : "-"}
                  </td>
                  <td>{r.collectionType || "-"}</td>
                  <td>
                    <button
                        className="slip-btn-collection-report-branch"
                        onClick={() => ViewDepositeCollectionReceipt(r)}
                      >
                        Receipt
                      </button>
                  </td>
                  {/* <td>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <button
                        className="slip-btn-collection-report-branch"
                        onClick={() => handleDownloadSlip(r)}
                      >
                        📄 PDF
                      </button>
                      <button
                        className="slip-btn-collection-report-branch"
                        onClick={() => handlePrintThermalSlip(r)}
                      >
                        🧾 Slip
                      </button>
                    </div>
                  </td> */}
                </tr>
              ))}
            </tbody>

            <tfoot>
              <tr className="CollectionReport-total-row">
                <td colSpan="4" style={{ textAlign: "right" }}>
                  Total:
                </td>
                <td style={{ fontWeight: "bold" }}>₹{totalAmount}</td>
                <td colSpan="4"></td>
              </tr>
            </tfoot>
          </table>
        )}
      </div>

      <div className="CollectionReport-pagination">
        <button
          className="pagination-btn"
          onClick={handlePrev}
          disabled={currentPage === 1}
        >
          ⬅ Prev
        </button>
        <span className="pagination-info">
          Page {currentPage} of {totalPages || 1}
        </span>
        <button
          className="pagination-btn"
          onClick={handleNext}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          Next ➡
        </button>
      </div>

      {/* -------- HIDDEN THERMAL SLIP -------- */}
      <div style={{ position: "absolute", left: "-10000px" }}>
        <div
          ref={slipRef}
          style={{
            width: "230px",
            padding: "10px",
            border: "1px solid #ccc",
            fontFamily: "Courier New, monospace",
            fontSize: "12px",
            lineHeight: "1.2",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <div style={{ fontWeight: "bold", fontSize: "14px" }}>
              {company?.name || "--"}
            </div>
            <div style={{ fontSize: "9px" }}>
              <b>Contact No.:</b> {company?.contact || "--"}
            </div>
            <div style={{ fontSize: "9px" }}>
              <b>Address:</b> {company?.address || "--"}
            </div>
          </div>

          <div
            style={{
              textAlign: "center",
              marginTop: "10px",
              fontWeight: "bold",
            }}
          >
            Deposite Collection Slip
          </div>

          <div
            style={{ borderBottom: "1px dashed #000", margin: "10px 0" }}
          />

          <div>
            <b>Customer Name:</b>{" "}
            {selectedLoan?.account?.customerName || "--"}
          </div>
          <div>
            <b>Account Number:</b>{" "}
            {selectedLoan?.account?.accountNo || "--"}
          </div>
          <div>
            <b>Installment No:</b>{" "}
            {selectedLoan?.installmentNo || "--"}
          </div>
          <div>
            <b>Amount:</b> ₹{selectedLoan?.amount || "--"}
          </div>
          <div>
            <b>Paid Date:</b>{" "}
            {selectedLoan?.collectionDate
              ? new Date(
                  selectedLoan.collectionDate
                ).toLocaleDateString("en-IN")
              : "-"}
          </div>
          <div>
            <b>Mode:</b> {selectedLoan?.collectionType || "--"}
          </div>

          <div
            style={{ borderBottom: "1px dashed #000", margin: "10px 0" }}
          />

          <div style={{ textAlign: "center" }}>Thank you!</div>
          <div style={{ textAlign: "center" }}>
            --- {company?.name?.split(" ")[0] || "End"} Slip ---
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepositCollectionReport;
